import { createSlice } from '@reduxjs/toolkit';

export const reliabilityV2Slice = createSlice({
  name: 'reliabilityV2',
  initialState: false,
  reducers: {},
});

export const { reducer: reliabilityV2Reducer } = reliabilityV2Slice;
